import { useSnackbar } from 'notistack';

/**
 * Custom hook for showing snackbar notifications.
 * This centralizes the notification logic and styling.
 * @returns {{notifySuccess: function, notifyError: function, notifyInfo: function, notifyWarning: function}}
 */
export const useNotifier = () => {
  const { enqueueSnackbar } = useSnackbar();

  const notifySuccess = (message) => {
    enqueueSnackbar(message, { variant: 'success' });
  };

  const notifyError = (message) => {
    enqueueSnackbar(message, { variant: 'error' });
  };

  const notifyInfo = (message) => {
    enqueueSnackbar(message, { variant: 'info' });
  };

  const notifyWarning = (message) => {
    enqueueSnackbar(message, { variant: 'warning' });
  };

  return { notifySuccess, notifyError, notifyInfo, notifyWarning };
};